import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import breadcrumb from "./locales/pt/breadcrumb.json";
import filter from "./locales/pt/filter.json";
import nonExecution from "./locales/pt/nonExecution.json";
import process from "./locales/pt/process.json";

const resources = {
  pt: {
    translation: {
      ...breadcrumb,
      ...filter,
      ...process,
      ...nonExecution,
    },
  },
};

export default i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "pt",
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});
